export const hotSearch = [
  { rank: 1, title: "夏日音乐节阵容公布", heat: 986000, trend: "up", tag: "爆" },
  { rank: 2, title: "新剧开播口碑反转", heat: 872000, trend: "up", tag: "热" },
  { rank: 3, title: "复古胶片风集体回潮", heat: 693000, trend: "same", tag: "热" },
  { rank: 4, title: "深夜食堂话题刷屏", heat: 615000, trend: "up", tag: "热" },
  { rank: 5, title: "综艺剪辑争议持续发酵", heat: 578000, trend: "down", tag: "新" },
  { rank: 6, title: "城市漫游路线爆火", heat: 462000, trend: "up", tag: "新" },
  { rank: 7, title: "虚拟主播集体上线", heat: 421000, trend: "down", tag: "" },
  { rank: 8, title: "老牌乐队宣布巡演", heat: 397000, trend: "new", tag: "新" },
  { rank: 9, title: "露营装备清单引全民补充", heat: 338000, trend: "same", tag: "" },
  { rank: 10, title: "年度趋势盘点十个词", heat: 286000, trend: "up", tag: "" },
];

export const liveFeed = [
  {
    time: "刚刚",
    user: "柠檬不加冰",
    content: "刚把新剧第四集刷完，剪辑节奏确实比前两集舒服太多，前面差点就弃了。",
    topic: "新剧开播口碑反转",
    likes: 328,
  },
  {
    time: "3 分钟前",
    user: "周日晚八点",
    content: "音乐节压轴那段直接封神，现场氛围透过屏幕都能感觉到。",
    topic: "夏日音乐节阵容公布",
    likes: 1246,
  },
  {
    time: "9 分钟前",
    user: "胶片收藏癖",
    content: "又开始用胶片拍日常了，颗粒感真的会让人慢下来，比加滤镜真诚很多。",
    topic: "复古胶片风集体回潮",
    likes: 512,
  },
  {
    time: "16 分钟前",
    user: "夜宵地图",
    content: "补充一个，我们这边巷子里那家开到凌晨四点，汤底是熬了一整晚的那种。",
    topic: "深夜食堂话题刷屏",
    likes: 874,
  },
  {
    time: "25 分钟前",
    user: "漫步者林",
    content: "城市漫游真的比赶景点舒服，走走停停一下午，回来精神比睡懒觉还好。",
    topic: "城市漫游路线爆火",
    likes: 401,
  },
  {
    time: "41 分钟前",
    user: "票务小助手",
    content: "提醒大家一定走官方渠道，二手转让风险太高了，别到时候进不去场。",
    topic: "老牌乐队宣布巡演",
    likes: 623,
  },
];